if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const formId = this.form.getAttribute('id');
      const potSelector = formId && document.getElementById(`pot-selector-${formId.replace('product-form-', '')}`);
      const pot = potSelector && potSelector.selectedPot;
      const body = pot ? this.buildBundleFormData(formData, pot) : formData;
      body.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
      config.body = body;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          
          // Store the variant ID(s) that were just added for filtering
          const variantId = formData.get('id');
          if (variantId) {
            window.recentlyAddedItems = pot ? [String(pot.id), String(variantId)] : [String(variantId)];
          }
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    
    // Pot first (tagged with the plant it was chosen for), then the plant with its own line properties.
    buildBundleFormData(formData, pot) {
      const body = new FormData();
      body.append('items[0][id]', pot.id);
      body.append('items[0][quantity]', 1);
      if (pot.handle) body.append('items[0][properties][_paired_plant]', pot.handle);

      body.append('items[1][id]', formData.get('id'));
      body.append('items[1][quantity]', formData.get('quantity') || 1);
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) body.append(`items[1][${key}]`, value);
      }
      if (formData.get('selling_plan')) body.append('items[1][selling_plan]', formData.get('selling_plan'));
      return body;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
